var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAccessManagement1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3999FB;}\r\n\t.st1{fill:#1D5CB2;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249,166.8c29.9,0,54.2-24.3,54.2-54.2S278.9,58.5,249,58.5s-54.2,24.3-54.2,54.2S219.1,166.8,249,166.8z  M249,73.9c21.3,0,38.7,17.4,38.7,38.7c0,18.7-13.3,34.3-31,37.9v-30.2h-15.5v30.2c-17.6-3.6-31-19.2-31-37.9 C210.3,91.3,227.7,73.9,249,73.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.3,89.4h15.5v15.5h-15.5V89.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M458.7,378.4l-39.4-8.7v-11.3c14-9.8,23.2-26,23.2-44.4v-15.5c0-27.2-20.2-49.8-46.5-53.6v-36.8l-71.5-28.6 l11-11l-11.1-16.6c2.2-4.3,4.1-8.8,5.6-13.4l19.5-3.9V90.8l-19.5-3.9c-1.5-4.6-3.3-9.1-5.6-13.4l11.1-16.6L304.7,26l-16.6,11.1 c-4.3-2.2-8.8-4.1-13.4-5.6L270.8,12h-43.7l-3.9,19.5c-4.6,1.5-9.1,3.3-13.4,5.6L193.3,26l-30.9,30.9l11.1,16.6 c-2.2,4.3-4.1,8.8-5.6,13.4l-19.5,3.9v43.7l19.5,3.9c1.5,4.6,3.3,9.1,5.6,13.4l-11.1,16.6l11,11l-71.5,28.6v36.8 c-26.2,3.8-46.5,26.3-46.5,53.6v15.5c0,18.4,9.2,34.6,23.2,44.4v11.3l-39.4,8.8C21.5,382.4,9,397.9,9,416.2V492h480v-75.8 C489,397.9,476.5,382.4,458.7,378.4z M403.8,373.7c-1.9,3-7.3,9.9-15.5,9.9s-13.6-6.9-15.5-9.9v-7.9c4.9,1.5,10.1,2.3,15.5,2.3 c5.4,0,10.6-0.8,15.5-2.3V373.7z M427.1,298.5v15.5c0,21.3-17.4,38.7-38.7,38.7c-21.3,0-38.7-17.4-38.7-38.7v-15.5 c0-21.3,17.4-38.7,38.7-38.7C409.7,259.7,427.1,277.1,427.1,298.5z M380.6,218.5v26.3c-26.2,3.8-46.5,26.3-46.5,53.6v15.5 c0,18.4,9.2,34.6,23.2,44.4v11.3l-38.7,8.6l-38.7-8.6v-11.3c14-9.8,23.2-26,23.2-44.4v-15.5c0-27.2-20.2-49.8-46.5-53.6v-31.6h14.1 l3.9-19.5c4.6-1.5,9.1-3.3,13.4-5.6l16.6,11.1l7.9-7.9L380.6,218.5z M334.2,476.5H163.8v-60.3c0-11,7.5-20.3,18.2-22.7l40.2-8.9 c4.4,5.9,13.2,14.5,26.8,14.5s22.3-8.6,26.8-14.5l40.2,8.9c10.7,2.4,18.2,11.7,18.2,22.7V476.5z M249,259.7 c21.3,0,38.7,17.4,38.7,38.7v15.5c0,21.3-17.4,38.7-38.7,38.7s-38.7-17.4-38.7-38.7v-15.5C210.3,277.1,227.7,259.7,249,259.7z  M249,368.1c5.4,0,10.6-0.8,15.5-2.3v7.9c-1.9,3-7.3,9.9-15.5,9.9s-13.6-6.9-15.5-9.9v-7.9C238.4,367.3,243.6,368.1,249,368.1z  M163.8,121.8v-18.3l16.5-3.3l1.2-4.7c1.6-6.5,4.2-12.7,7.6-18.4l2.5-4.2l-9.3-14L195.2,46l14,9.3l4.2-2.5c5.7-3.4,11.9-6,18.4-7.6 l4.7-1.2l3.3-16.5h18.3l3.3,16.5l4.7,1.2c6.5,1.6,12.7,4.2,18.4,7.6l4.2,2.5l14-9.3l12.9,12.9l-9.3,14l2.5,4.2 c3.4,5.7,6,11.9,7.6,18.4l1.2,4.7l16.5,3.3v18.3l-16.5,3.3l-1.2,4.7c-1.6,6.5-4.2,12.7-7.6,18.4l-2.5,4.2l9.3,14l-12.9,12.9 l-14-9.3l-4.2,2.5c-5.7,3.4-11.9,6-18.4,7.6l-4.7,1.2l-3.3,16.5h-18.3l-3.3-16.5l-4.7-1.2c-6.5-1.6-12.7-4.2-18.4-7.6l-4.2-2.5 l-14,9.3l-12.9-12.9l9.3-14l-2.5-4.2c-3.4-5.7-6-11.9-7.6-18.4l-1.2-4.7L163.8,121.8z M185.4,191.3l7.9,7.9l16.6-11.1 c4.3,2.2,8.8,4.1,13.4,5.6l3.9,19.5h14.1v31.6c-26.2,3.8-46.5,26.3-46.5,53.6v15.5c0,18.4,9.2,34.6,23.2,44.4v11.3l-38.7,8.6 l-38.7-8.6v-11.3c14-9.8,23.2-26,23.2-44.4v-15.5c0-27.2-20.2-49.8-46.5-53.6v-26.3L185.4,191.3z M70.9,313.9v-15.5 c0-21.3,17.4-38.7,38.7-38.7s38.7,17.4,38.7,38.7v15.5c0,21.3-17.4,38.7-38.7,38.7S70.9,335.3,70.9,313.9z M109.6,368.1 c5.4,0,10.6-0.8,15.5-2.3v7.9c-1.9,3-7.3,9.9-15.5,9.9c-8.2,0-13.6-6.9-15.5-9.9v-7.9C99.1,367.3,104.3,368.1,109.6,368.1z  M24.5,416.2c0-11,7.5-20.3,18.2-22.7l40.2-8.9c4.4,5.9,13.2,14.5,26.8,14.5s22.3-8.6,26.8-14.5l22.6,5c-6.6,7-10.7,16.3-10.7,26.6 v60.3H24.5V416.2z M473.5,476.5H349.6v-60.3c0-10.3-4-19.6-10.7-26.6l22.6-5c4.4,5.9,13.2,14.5,26.8,14.5 c13.5,0,22.3-8.6,26.8-14.5l40.2,8.9c10.7,2.4,18.2,11.7,18.2,22.7V476.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.6,66.2h15.5v15.5h-15.5V66.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.6,112.6h15.5v15.5h-15.5V112.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.6,159.1h15.5v15.5h-15.5V159.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.6,112.6h15.5v15.5h-15.5V112.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.6,159.1h15.5v15.5h-15.5V159.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.6,205.5h15.5V221h-15.5V205.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.9,66.2h15.5v15.5h-15.5V66.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.9,112.6h15.5v15.5h-15.5V112.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.9,159.1h15.5v15.5h-15.5V159.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.9,112.6h15.5v15.5H70.9V112.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.9,159.1h15.5v15.5H70.9V159.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.9,205.5h15.5V221H70.9V205.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAccessManagement1);
export default __webpack_public_path__ + "static/media/user-access-management-1.60d62d85ea5de716a122cbf484de3c74.svg";
export { ForwardRef as ReactComponent };